
export enum Sizes {
    SIZE_3XS = "3xs",
    SIZE_2XS = "2xs",
    SIZE_XS = "xs",
    SIZE_S = "s",
    SIZE_SM = "sm",
    SIZE_M = "m",
    SIZE_ML = "ml",
    SIZE_L = "l",
    SIZE_XL = "xl",
    SIZE_2XL = "2xl",
    SIZE_3XL = "3xl",
    SIZE_4XL = "4xl",
    SIZE_5XL = "5xl"
}